module.exports = __webpack_public_path__ + "img/open_credit_limit.b2e67c7b.png";